import Icon from "../components/icons";

const SocialBar = () => {
  return (
    <div className="social-bar d-none d-md-block">
      <a
        className="social-bar__link social-bar__link--first"
        title="Facebook"
        href="https://www.facebook.com/festivaldellascienza/"
      >
        <Icon name="facebook" />
      </a>

      <a
        className="social-bar__link"
        title="Twitter"
        href="https://twitter.com/fdellascienza?lang=it"
      >
        <Icon name="twitter" />
      </a>

      <a
        className="social-bar__link"
        title="YouTube"
        href="https://www.youtube.com/user/FestivalScienza"
      >
        <Icon name="youtube" />
      </a>

      <a
        className="social-bar__link"
        title="Instagram"
        href="https://www.instagram.com/festivalscienza/"
      >
        <Icon name="instagram" />
      </a>
    </div>
  );
};

export default SocialBar;
